import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Chart, registerables } from 'chart.js';
import configApi from '../../config';

Chart.register(...registerables);

const TrafficByDayChart = () => {
    const chartRef = useRef(null);
    const [chartInstance, setChartInstance] = useState(null);
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const fetchTrafficData = async () => {
        try {
            const response = await axios.get(
                `${configApi.apiEndpoint}/api/Stats/TrafficByDay`,
                config
            );
            createChart(response.data);
        } catch (error) {
            console.error('Chyba pri načítavaní údajov o premávke:', error);
        }
    };

    const createChart = (data) => {
        const labels = data.map(item => item.day);
        const counts = data.map(item => item.count);

        const ctx = chartRef.current.getContext('2d');
        const gradient = ctx.createLinearGradient(0, 0, 0, 300);
        gradient.addColorStop(0, 'rgba(156, 39, 176, 0.8)'); // Purple material design color
        gradient.addColorStop(1, 'rgba(156, 39, 176, 0.2)');

        const chartConfig = {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Celkový počet rezervácií',
                    data: counts,
                    backgroundColor: gradient,
                    borderColor: '#9c27b0',
                    borderWidth: 1,
                    borderRadius: 4,
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'Počet termínov'
                        }
                    },
                    x: {
                        title: {
                            display: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: false
                    }
                }
            }
        };

        if (chartInstance) {
            chartInstance.data = chartConfig.data;
            chartInstance.options = chartConfig.options;
            chartInstance.update();
        } else {
            const newChartInstance = new Chart(ctx, chartConfig);
            setChartInstance(newChartInstance);
        }
    };

    useEffect(() => {
        fetchTrafficData();
    }, []);

    return (
        <div className="card-custom h-100">
            <div className="card-custom-header">
                <h5 className="m-0">Vyťaženosť podľa dní</h5>
            </div>
            <div style={{ height: '300px' }}>
                <canvas ref={chartRef}></canvas>
            </div>
        </div>
    );
};

export default TrafficByDayChart;
